import React from 'react';

import Button from 'components/Button/Button';
import { getEnvironmentVariables } from 'services/environment-variables/environment-variables';

interface ComponentProps {
  styles: {
    [key: string]: string;
  };
  closeModal: () => void;
}

const DoorDashWarning: React.FC<ComponentProps> = ({ styles, closeModal }) => {
  const { DOORDASH_MIN_IMAGE_WIDTH_PX, DOORDASH_MIN_IMAGE_HEIGHT_PX } = getEnvironmentVariables();
  const [title, body1, body2] = [
    'Photo updates can take up to 5 days.',
    `It may take up to 5 days for photos to be approved by DoorDash.`,
    `Please ensure photo is minimum ${DOORDASH_MIN_IMAGE_WIDTH_PX}x${DOORDASH_MIN_IMAGE_HEIGHT_PX}px.`
  ];

  return (
    <div
      data-testid="doordash-warning-confirm"
      role="dialog"
      aria-labelledby="doordash-warning-title"
      aria-describedby="doordash-warning-description"
    >
      <h2 id="doordash-warning-title" className={styles.NoMargin}>
        {title}
      </h2>
      <p
        id="doordash-warning-description"
        data-testid="doordash-warning-confirm-copy"
        style={{ whiteSpace: 'pre-wrap' }}
      >
        {body1}
        {'\n'}
        {body2}
      </p>
      <div className={`${styles.ButtonRow} ${styles.Single}`}>
        <Button
          onClick={() => {
            closeModal();
          }}
        >
          Ok, got it
        </Button>
      </div>
    </div>
  );
};

export default DoorDashWarning;
